// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16BZD","select":"styles_select__izp5z"};